"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.homeZhReducer = void 0;
var HomeZhAction_1 = require("@/pages/homeZh/actions/HomeZhAction");
var HomeZhState_init_1 = require("@/pages/homeZh/states/HomeZhState.init");
var typesafe_actions_1 = require("typesafe-actions");
exports.homeZhReducer = function (state, action) {
    if (state === void 0) { state = HomeZhState_init_1.defaultHomeZhState; }
    switch (action.type) {
        case typesafe_actions_1.getType(HomeZhAction_1.default.onCalcPriceChanged): {
            return __assign(__assign({}, state), { calcPriceValue: action.payload });
        }
        case typesafe_actions_1.getType(HomeZhAction_1.default.onCalcLoanPercentChanged): {
            return __assign(__assign({}, state), { calcLoanPercentValue: action.payload });
        }
        case typesafe_actions_1.getType(HomeZhAction_1.default.onCalcRateChanged): {
            return __assign(__assign({}, state), { calcRateValue: action.payload });
        }
        case typesafe_actions_1.getType(HomeZhAction_1.default.onCalcTenorChanged): {
            return __assign(__assign({}, state), { calcTenorValue: action.payload });
        }
        case typesafe_actions_1.getType(HomeZhAction_1.default.onCalcOwnPropChanged): {
            return __assign(__assign({}, state), { calcOwnProp: action.payload });
        }
        case typesafe_actions_1.getType(HomeZhAction_1.default.onCalcHkBuyerChanged): {
            return __assign(__assign({}, state), { calcHkBuyer: action.payload });
        }
        case typesafe_actions_1.getType(HomeZhAction_1.default.onCalcViewChanged): {
            return __assign(__assign({}, state), { calcView: action.payload });
        }
        case typesafe_actions_1.getType(HomeZhAction_1.default.onToggleDistrictPanel): {
            return __assign(__assign({}, state), { districtActive: !state.districtActive });
        }
        case typesafe_actions_1.getType(HomeZhAction_1.default.onSetListingType): {
            return __assign(__assign({}, state), { searchType: action.payload });
        }
        case typesafe_actions_1.getType(HomeZhAction_1.default.setArea): {
            return __assign(__assign({}, state), { areaActive: action.payload });
        }
        case typesafe_actions_1.getType(HomeZhAction_1.default.onKeywordChanged): {
            return __assign(__assign({}, state), { keyword: action.payload });
        }
        case typesafe_actions_1.getType(HomeZhAction_1.default.onSetKeywordActive): {
            return __assign(__assign({}, state), { keywordActive: action.payload });
        }
        case typesafe_actions_1.getType(HomeZhAction_1.default.setKeywordSuggestions): {
            return __assign(__assign({}, state), { keywordSuggestions: action.payload });
        }
        case typesafe_actions_1.getType(HomeZhAction_1.default.setKeywordHistories): {
            return __assign(__assign({}, state), { keywordHistories: action.payload });
        }
        case typesafe_actions_1.getType(HomeZhAction_1.default.setKeywordLoading): {
            return __assign(__assign({}, state), { keywordSuggestionsLoading: action.payload });
        }
        case typesafe_actions_1.getType(HomeZhAction_1.default.setKeyword): {
            return __assign(__assign({}, state), { keyword: action.payload });
        }
        case typesafe_actions_1.getType(HomeZhAction_1.default.setSuggestionFocus): {
            var keywordSuggestions = state.keywordSuggestions.map(function (it) { return (it.id === action.payload.id) ? (__assign(__assign({}, it), { isFocus: true })) : (__assign(__assign({}, it), { isFocus: false })); });
            return __assign(__assign({}, state), { keywordSuggestions: keywordSuggestions, isSearchKeywordFocus: false });
        }
        case typesafe_actions_1.getType(HomeZhAction_1.default.setHistoryFocus): {
            var keywordHistories = state.keywordHistories.map(function (it) { return (it.id === action.payload.id) ? (__assign(__assign({}, it), { isFocus: true })) : (__assign(__assign({}, it), { isFocus: false })); });
            return __assign(__assign({}, state), { keywordHistories: keywordHistories, isSearchKeywordFocus: false });
        }
        case typesafe_actions_1.getType(HomeZhAction_1.default.setSearchKeywordFocus): {
            return __assign(__assign({}, state), { isSearchKeywordFocus: action.payload, keywordSuggestions: state.keywordSuggestions.map(function (it) { return (__assign(__assign({}, it), { isFocus: false })); }) });
        }
        case typesafe_actions_1.getType(HomeZhAction_1.default.onKeywordNext): {
            if (!state.keyword && state.keywordHistories.length) {
                var currentIndex_1 = state.keywordHistories.findIndex(function (it) { return it.isFocus; });
                if (currentIndex_1 === -1 || currentIndex_1 === state.keywordHistories.length - 1) {
                    return __assign(__assign({}, state), { keywordHistories: state.keywordHistories.map(function (it, i) { return (i === 0) ? (__assign(__assign({}, it), { isFocus: true })) : (__assign(__assign({}, it), { isFocus: false })); }) });
                }
                return __assign(__assign({}, state), { keywordHistories: state.keywordHistories.map(function (it, i) { return (i === currentIndex_1 + 1) ? (__assign(__assign({}, it), { isFocus: true })) : (__assign(__assign({}, it), { isFocus: false })); }) });
            }
            if (state.isSearchKeywordFocus) {
                return __assign(__assign({}, state), { isSearchKeywordFocus: false, keywordSuggestions: state.keywordSuggestions.map(function (it, i) { return i === 0 ? (__assign(__assign({}, it), { isFocus: true })) : (__assign(__assign({}, it), { isFocus: false })); }) });
            }
            var selectedSuggestionIndex_1 = state.keywordSuggestions.findIndex(function (it) { return it.isFocus; });
            if (selectedSuggestionIndex_1 >= 0) {
                if (selectedSuggestionIndex_1 === state.keywordSuggestions.length - 1) {
                    return __assign(__assign({}, state), { isSearchKeywordFocus: true, keywordSuggestions: state.keywordSuggestions.map(function (it) { return (__assign(__assign({}, it), { isFocus: false })); }) });
                }
                return __assign(__assign({}, state), { keywordSuggestions: state.keywordSuggestions.map(function (it, i) { return i === selectedSuggestionIndex_1 + 1 ? (__assign(__assign({}, it), { isFocus: true })) : (__assign(__assign({}, it), { isFocus: false })); }) });
            }
            return __assign(__assign({}, state), { isSearchKeywordFocus: true });
        }
        case typesafe_actions_1.getType(HomeZhAction_1.default.onKeywordPrevious): {
            if (!state.keyword && state.keywordHistories.length) {
                var currentIndex_2 = state.keywordHistories.findIndex(function (it) { return it.isFocus; });
                if (currentIndex_2 === -1 || currentIndex_2 === 0) {
                    return __assign(__assign({}, state), { keywordHistories: state.keywordHistories.map(function (it, i) { return (i === state.keywordHistories.length - 1) ? (__assign(__assign({}, it), { isFocus: true })) : (__assign(__assign({}, it), { isFocus: false })); }) });
                }
                return __assign(__assign({}, state), { keywordHistories: state.keywordHistories.map(function (it, i) { return (i === currentIndex_2 - 1) ? (__assign(__assign({}, it), { isFocus: true })) : (__assign(__assign({}, it), { isFocus: false })); }) });
            }
            if (state.isSearchKeywordFocus) {
                if (state.keywordSuggestions.length) {
                    return __assign(__assign({}, state), { isSearchKeywordFocus: false, keywordSuggestions: state.keywordSuggestions.map(function (it, i) { return i === state.keywordSuggestions.length - 1 ? (__assign(__assign({}, it), { isFocus: true })) : (__assign(__assign({}, it), { isFocus: false })); }) });
                }
                return __assign(__assign({}, state), { isSearchKeywordFocus: true });
            }
            if (state.keywordSuggestions.length) {
                var selectedSuggestionIndex_2 = state.keywordSuggestions.findIndex(function (it) { return it.isFocus; });
                if (selectedSuggestionIndex_2 >= 0) {
                    if (selectedSuggestionIndex_2 === 0) {
                        return __assign(__assign({}, state), { isSearchKeywordFocus: true, keywordSuggestions: state.keywordSuggestions.map(function (it) { return (__assign(__assign({}, it), { isFocus: false })); }) });
                    }
                    return __assign(__assign({}, state), { keywordSuggestions: state.keywordSuggestions.map(function (it, i) { return i === selectedSuggestionIndex_2 - 1 ? (__assign(__assign({}, it), { isFocus: true })) : (__assign(__assign({}, it), { isFocus: false })); }) });
                }
                return __assign(__assign({}, state), { isSearchKeywordFocus: false, keywordSuggestions: state.keywordSuggestions.map(function (it, i) { return i === state.keywordSuggestions.length - 1 ? (__assign(__assign({}, it), { isFocus: true })) : (__assign(__assign({}, it), { isFocus: false })); }) });
            }
            return __assign(__assign({}, state), { isSearchKeywordFocus: true });
        }
    }
    return state;
};
